import {Component, computed, inject, signal, WritableSignal} from '@angular/core';
import {TypedBaseWidgetComponent} from '@core/instantsearch/types-based-widget';
import connectStats, {
  StatsConnectorParams,
  StatsRenderState,
  StatsWidgetDescription
} from 'instantsearch.js/es/connectors/stats/connectStats';
import {InstantSearchComponent} from '@core/instantsearch/components/instantsearch.component';
import {StoreConfigService} from '@core/services/store-config.service';

@Component({
  selector: 'app-instantsearch-stats',
  template: `
    <div [class]="cx()">
      <span class="search-results-count" i18n>
        {{ nbHits() }}
        produkter fundet
      </span>

      @if (currentAlgoliaIndex() === algoliaDefaultIndex()) {
        <span class="search-sort-text" i18n>- Bedste pris vises altid først</span>
      }
    </div>
  `,
})
export class InstantSearchStatsComponent extends TypedBaseWidgetComponent<
  StatsWidgetDescription,
  StatsConnectorParams
> {
  instantSearchInstance = inject(InstantSearchComponent);
  storeConfigService = inject(StoreConfigService);

  algoliaDefaultIndex = computed(() => this.storeConfigService.storeConfig()?.algoliaDefaultIndex);

  currentAlgoliaIndex = computed(() => this.instantSearchInstance.currentState()?.index);
  nbHits = computed(() => this.state()?.nbHits)

  public override state: WritableSignal<StatsRenderState | undefined> = signal(undefined);

  constructor() {
    super('Stats');
    this.createWidget(connectStats, {});
  }

}
